import React from 'react';
import { useAppDispatch, useAppSelector, useAppStore } from '@/lib/hooks';
import { setModalName } from '@/lib/slices/modal-slice';
import ModalComponent from '@/common/components/modals/ModalComponent';
import Button from '@/common/components/ui/Button';
import { CancelIcon } from '@/assets/icons/button';

interface TextModalProps {
  modalName: string;
  title: string;
  subtitle?: string;
  displayText: string;
  className?: string;
  closeOnClickOff?: boolean;
}

export default function TextModal({
  modalName,
  title,
  subtitle,
  displayText,
  className = 'max-w-[900px] w-full',
  closeOnClickOff = true,
}: TextModalProps) {
  const store = useAppStore();
  const dispatch = useAppDispatch();

  const modalVisible: boolean = useAppSelector(() => store.getState().modal.visible);
  const currentModalName: string = useAppSelector(() => store.getState().modal.name);

  const handleClose = () => {
    dispatch(setModalName(''));
  };

  const isOpen = modalVisible && currentModalName === modalName;

  return (
    <ModalComponent
      isOpen={isOpen}
      onRequestClose={handleClose}
      contentLabel={title}
      contentSubtitle={subtitle}
      className={className}
      closeOnClickOff={closeOnClickOff}
      footer={
        <div className='w-full pt-4 flex flex-col gap-2'>
          <div className='flex flex-row gap-8 py-2'>
            <Button outline onClick={handleClose}>
              <CancelIcon className='w-[20px] h-[20px] mr-2' /> Close
            </Button>
          </div>
        </div>
      }
    >
      <div className='flex flex-col gap-2 bg-surface_gray_200 rounded-lg p-4 border border-border_gray_300 flex-1 min-h-0'>
        <div className='max-h-[65vh] overflow-y-auto pr-2 flex-1'>
          <pre className='font-[inherit] whitespace-pre-wrap text-base'>{displayText}</pre>
        </div>
      </div>
    </ModalComponent>
  );
}
